import React, { useEffect, useRef } from 'react';
import './cardSection1.css';

const CardSection1 = ({ onClose }) => {
  const cardRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (cardRef.current && !cardRef.current.contains(event.target)) {
        onClose(); // Fecha ao clicar fora
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="card-overlay">
      <div className="hotel-card" ref={cardRef}>
        {/* BOTÃO DE FECHAR DENTRO DO CARD */}
        <button className="close-button-inside" onClick={onClose}>Fechar</button>

       {/**  <h2>Hotéis Parceiros</h2> */}

        <div className="hotel-item">
            <h1>Enjoy Olimpia Park Resort</h1>
          <p>- Para hospedagem no Enjoy Olimpia Park Resort<br/>
                      - Período de estádio : 15 a 21/09 <br/>
                     - O desconto e aplicado com mínimo de 1 diária <br/>
                      - Cupom: 15%OFFGRUPOTOTAL</p>
          <a
            href="https://www.enjoyhoteis.com.br/reservas/"
            target="_blank"
            rel="noopener noreferrer"
            className="hotel-button"
          >
            Reservar
          </a>
        </div>

         <div className="hotel-item2">
            <h1>Hotel Villa Rebellato</h1>
          <p>
TARIFAS <br/>
- Individual: R$ 140,00 a diária  <br/>
- Duplo: R$ 210,00 a diária     <br/>
- Triplo: R$ 290,00 a diária    <br/>
- Quádruplo: R$ 360,00 a diária   <br/>
Central de Reservas: <br/>
 Telefone: (17) 3281-9221 | WhatsApp: (17) 99156-4144  <br/>
 
Informar que a reserva será para o evento do Grupo Total.</p>
          <a
            href="https://www.hotelvillarebellato.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            className="hotel-button"
          >
            Reservar
          </a>
        </div>

        <div className="hotel-item3">
            <h1>Wyndham Olimpia Royal Hotels</h1>
          <p>
            
            
          TARIFAS <br/>
- Quarto duplo - R$429,00 <br/>
- Quarto triplo - R$599,00 <br/>
 
Central de Reservas: <br/>

 (WhatsApp): 17 99665-8856<br/>
  - Fixo 17 3280.8101
 
Informar que a reserva será para o evento Rede Total <br/>- Evento 42° Feira de Negócios
                
                
                </p>
          <a
            href="https://termasdeolimpia.com.br/hospedagem/wyndham-olimpia-royal-hotels.html?gad_source=1&gad_campaignid=278760870&gbraid=0AAAAADmH3fLN4KpOpvzcqlVsisPWgh-jR&gclid=EAIaIQobChMIoZLipPX4jQMVNTdECB2Q4SQtEAAYASAAEgJCk_D_BwE/"
            target="_blank"
            rel="noopener noreferrer"
            className="hotel-button"
          >
            Reservar
          </a>
        </div>
      </div>
    </div>
  );
};

export default CardSection1;
